/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ExpenseDto } from '../models/ExpenseDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class ExpenseService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns ExpenseDto
     * @throws ApiError
     */
    public expenseGetAvailableExpenses(): Observable<Array<ExpenseDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/expenses',
        });
    }
}
